import * as React from "react";
import {Link} from "react-router-dom";
import {ProductsEnum} from "@ferry/journey-services";
import {getBrandFromPolicyNumber, resourcesHelper} from "@ferry/portal-core";

interface IProps {
    policyNumber: string;
}

export class OtherMissedPaymentBanner extends React.Component<IProps> {

    public render(): React.ReactNode {
        const brandName: string = this.props.policyNumber ?
            getBrandFromPolicyNumber(this.props.policyNumber)! :
            resourcesHelper.THEME_NAME;

        return (
            <div className="inner-container">
                <div className="banner error-banner">
                    <div className="banner-icon" />
                    <div className="banner-text">
                        <span>We didn't receive payment for your {brandName} policy this month.{' '}
                            You can </span>
                        <Link id={"payNow"}
                              className="btn btn-white-dashboard"
                              state={{
                                  verifyCardFailed: false,
                                  product: ProductsEnum.WOLF_MOTOR
                              }}
                              to={{
                                  pathname: `/dashboard/account/missedPolicyPayment/${this.props.policyNumber}`,
                              }}> Pay now
                        </Link>
                    </div>
                </div>
            </div>
        );
    }
}
